import {Pipe, PipeTransform, Injectable} from '@angular/core';

export class Selectable {
  constructor(public selected: boolean = false, public label: string) {

  }
}

@Pipe({
  name: 'selected',
  pure: false
})
@Injectable()
export class SelectedPipe implements PipeTransform {
  transform(items: Selectable[]): any {
    if (!items) {
      return items;
    }
    return items.filter(item => item.selected);
  }
}


